import { createFileRoute } from "@tanstack/react-router"
import { defaultMeta } from "@/lib/seo"

export const Route = createFileRoute(`/_public/privacy`)({
  ssr: true,
  head: () =>
    defaultMeta({
      title: `Privacy Policy`,
      description: `Learn how ChicTravel handles account, trip, and usage information.`,
      path: `/privacy`,
    }),
  component: PrivacyPage,
})

function PrivacyPage() {
  return (
    <main className="max-w-3xl mx-auto px-6 py-16 space-y-8">
      <div className="space-y-3">
        <h1 className="text-4xl font-extrabold tracking-tight">
          Privacy Policy
        </h1>
        <p className="text-muted-foreground">Last updated May 26, 2026</p>
      </div>

      <section className="space-y-3">
        <h2 className="text-xl font-bold">Information We Collect</h2>
        <p className="text-muted-foreground leading-relaxed">
          ChicTravel collects the information needed to provide trip planning,
          collaboration, account access, billing, and support. This may include
          account details, trip content, uploaded files, destinations, saved
          places, messages, and product usage data.
        </p>
      </section>

      <section className="space-y-3">
        <h2 className="text-xl font-bold">How We Use Information</h2>
        <p className="text-muted-foreground leading-relaxed">
          We use information to operate ChicTravel, sync and share trips,
          generate travel suggestions, improve product quality, secure accounts,
          process subscriptions, and respond to support requests.
        </p>
      </section>

      <section className="space-y-3">
        <h2 className="text-xl font-bold">Sharing</h2>
        <p className="text-muted-foreground leading-relaxed">
          Trip content may be visible to collaborators you invite and to others
          when you publish a guide or use a public sharing feature. We also work
          with service providers for hosting, analytics, authentication, maps,
          AI features, email, and payments.
        </p>
      </section>

      <section className="space-y-3">
        <h2 className="text-xl font-bold">Contact</h2>
        <p className="text-muted-foreground leading-relaxed">
          Questions about privacy can be sent through the contact page.
        </p>
      </section>
    </main>
  )
}
